export const uuid = (): string => {
    const c: Crypto | undefined =
        typeof crypto !== "undefined" ? crypto : undefined;

    if (typeof c?.randomUUID === "function") {
        return c.randomUUID();
    }

    if (typeof c?.getRandomValues === "function") {
        const bytes = c.getRandomValues(new Uint8Array(16));
        bytes[6] = (bytes[6] & 0x0f) | 0x40;
        bytes[8] = (bytes[8] & 0x3f) | 0x80;

        let hex = "";
        for (let i = 0; i < bytes.length; i++) {
            const b = bytes[i].toString(16);
            hex += b.length === 1 ? "0" + b : b;
        }
        return [
            hex.slice(0, 8),
            hex.slice(8, 12),
            hex.slice(12, 16),
            hex.slice(16, 20),
            hex.slice(20),
        ].join("-");
    }

    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (ch) => {
        const r = (Math.random() * 16) | 0;
        const v = ch === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};
